import { render, staticRenderFns } from "./newspage.vue?vue&type=template&id=e25e6790&scoped=true"
import script from "./newspage.vue?vue&type=script&lang=js"
export * from "./newspage.vue?vue&type=script&lang=js"
import style0 from "./newspage.vue?vue&type=style&index=0&id=e25e6790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25e6790",
  null
  
)

export default component.exports